import { render, staticRenderFns } from "./InvoiceSection.vue?vue&type=template&id=00b386d2&"
import script from "./InvoiceSection.vue?vue&type=script&lang=js&"
export * from "./InvoiceSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection})
